import React, { useContext, useEffect, useState } from "react";
import classes from "./ViewTab.module.css";
import Reviews from "./Reviews";
import AuthContext from "../../Common/authContext";
import { useDispatch, useSelector } from "react-redux";
import HtmlFields from "../../Common/HtmlFields";
import { addSearchData, editSearchData, resetSearchData } from "../../redux/productSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAddBox } from "react-icons/md";

const ViewTab = () => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const selectedBook = useSelector((state) => state.products.selectedBook[0]);
  const user = useSelector((state) => state.products.userInfo);
  const authCtx = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isclicked, setisclicked] = useState("resume");
  const [categoryItem, setCategoryItem] = useState(null);

  const getToken = () => {
    return sessionStorage.getItem("token");
  };

  const token = getToken();

  const handleSuivreCollab = async (collab) => {
    if (!user) {
      // If user is not defined, throw an error
      toast.error(
        `${
          language === "eng"
            ? "Please log in first"
            : "Veuillez d'abord vous connecter"
        }`
      );
      return;
    }

    try {
      const collaborators = authCtx.collaborators;

      const cleanedAuteur = collab.trim();
      // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
      const collaborator = collaborators.find((collaborator) => {
        const fullName = `${collaborator.nom.trim()}`;
        return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
        throw new Error("Collaborator not found");
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`,
        {
          collaborator_id: collaborator.id,
          ecom_type: "albouraq",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the headers
          },
        }
      );

      // console.log(response.data);
      toast.success(`${collaborator.nom} subscribed successfully!`, {
        hideProgressBar: true,
      }); // You can handle the response here
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response?.data?.error || error.message);
    }
  };

  const handleSuivreCollection = async () => {
    if (!user) {
      // If user is not defined, throw an error
      toast.error(
        `${
          language === "eng"
            ? "Please log in first"
            : "Veuillez d'abord vous connecter"
        }`
      );
      return;
    }

    try {
      // Fetch the list of collaborators
      const collectionsResponse = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/collections?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const collections = collectionsResponse.data;

      const cleanedCollec = selectedBook?.dc_collection.trim();
      // Find the collaborator whose nom + prenom matches selectedBook?.dc_auteur
      const Collection = collections.find((collaborator) => {
        const fullName = `${collaborator.nom}`;
        // console.log(fullName.toLowerCase())
        // console.log(cleanedCollec.toLowerCase())
        return fullName.toLowerCase() === cleanedCollec.toLowerCase();
      });

      if (!Collection) {
        throw new Error("Collection not found");
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`,
        {
          collection_id: Collection.id,
          ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the headers
          },
        }
      );

      // console.log(response.data);
      toast.success(
        `${
          language === "eng"
            ? `${Collection.nom} subscribed successfully!`
            : `${Collection.nom} abonné avec succès !!`
        }`,
        { hideProgressBar: true }
      ); // You can handle the response here
    } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message, {
        hideProgressBar: true,
      });
    }
  };

  useEffect(() => {
    const foundItem = authCtx.categories.find(
      (category) => category.id === selectedBook?.b_usr_articletheme_id
    );
    setCategoryItem(foundItem);
  }, [selectedBook?.b_usr_articletheme_id, authCtx.categories]);

  const handleSuivreCategory = async () => {
    if (!user) {
      // If user is not defined, throw an error
      toast.error(
        `${
          language === "eng"
            ? "Please log in first"
            : "Veuillez d'abord vous connecter"
        }`,
        { hideProgressBar: true }
      );
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}/subscriptions`,
        {
          category_id: categoryItem?.id,
          ecom_type: `${process.env.REACT_APP_ECOM_TYPE}`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the headers
          },
        }
      );
      // console.log(response.data);
      toast.success(
        `${
          language === "eng"
            ? `${categoryItem?._nom} subscribed successfully!`
            : `${categoryItem._nom} abonné avec succès !!`
        }`,
        { hideProgressBar: true }
      ); // You can handle the response here
    } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error, { hideProgressBar: true });
    }
  };

  const handleCatClick = async () => {
    // Retrieve the existing categories from localStorage (or initialize an empty array)
    let storedCategories = JSON.parse(localStorage.getItem("categories")) || [];

    if (storedCategories.includes(categoryItem?.id)) {
      // If the clicked category is already selected, remove it
      return navigate(`/products`);
    } else {
      // Otherwise, add the new category
      storedCategories.push(categoryItem?.id);
    }

    // Update localStorage
    localStorage.setItem("categories", JSON.stringify(storedCategories));

    // Dispatch action to update search data with the updated category list
    dispatch(addSearchData({ category: storedCategories }));

    navigate(`/products`);
  };

  
    const handleFilterCollaborator = (collaboratorId) => {
      localStorage.removeItem("categories");
      localStorage.removeItem("publishers");
      localStorage.removeItem("collections");
      dispatch(resetSearchData());
      dispatch(addSearchData({ collaborators: collaboratorId }));
      navigate(`/products`);
    }

    const handleFilterPublisher = (publisherId) => {
      localStorage.removeItem("categories");
      localStorage.removeItem("publishers");
      localStorage.removeItem("collections");
      dispatch(resetSearchData());
      // Get existing publishers from localStorage or initialize empty array
      const existingPublishers = JSON.parse(localStorage.getItem('publishers')) || [];
      // Add the new publisher ID if it doesn't already exist
      if (!existingPublishers.includes(publisherId)) {
        existingPublishers.push(publisherId);
      }
      // Store the updated array back to localStorage
      localStorage.setItem("publishers", JSON.stringify(existingPublishers));
      navigate(`/products`);
    }

    const handleFilterMultiproduct = (multiproductId) => {
      // Clear other filters to focus on this multiproduct
      localStorage.removeItem('categories');
      localStorage.removeItem('publishers');
      localStorage.removeItem('collections');
      dispatch(resetSearchData());

      // Toggle the multiproduct id in localStorage (same behavior as handleMultiProductsChange)
      const existing = JSON.parse(localStorage.getItem('multiproductids')) || [];
      let updated = [];
      if (existing.includes(multiproductId)) {
        updated = existing.filter(id => id !== multiproductId);
      } else {
        updated = [...existing, multiproductId];
      }
      localStorage.setItem('multiproductids', JSON.stringify(updated));

      navigate('/products');
    }
  return (
    <div className={classes.tabview}>
      <div className={classes.tabview_con}>
        <div className={classes.tab_content}>
          <div className={classes.btns_con}>
            <button
              className={`${
                isclicked === "resume" ? classes.btnleft_after : classes.btnleft
              }`}
              onClick={() => setisclicked("resume")}
            >
              {language === "eng" ? "Description" : "Résumé"}
            </button>
            <button
              className={`${
                isclicked === "caractéristiques"
                  ? classes.btn_after
                  : classes.btn
              }`}
              onClick={() => setisclicked("caractéristiques")}
            >
              {language === "eng" ? "Characteristics" : "Caractéristiques"}
            </button>
            <button
              className={`${
                isclicked === "commentaires"
                  ? classes.btnright_after
                  : classes.btnright
              }`}
              onClick={() => setisclicked("commentaires")}
            >
              {language === "eng" ? "Comments" : "Commentaires"}
              {/* <span className={classes.CommentairesNB}>4</span> */}
            </button>
          </div>
          <div className={classes.content}>
            {isclicked === "resume" && (
              <div className={classes.resume_content}>
                <p>
                  <HtmlFields htmlContent={selectedBook?.descriptif} />
                </p>
              </div>
            )}
            {isclicked === "caractéristiques" && (
              <div>
                {selectedBook?.collaborators && selectedBook?.collaborators.length > 0 && (() => {
                  // Group collaborators by type_id
                  const groupedCollaborators = selectedBook?.collaborators.reduce((acc, collab) => {
                    const typeId = collab.type_id;
                    if (!acc[typeId]) {
                      acc[typeId] = {
                        type: collab.type,
                        type_fr: collab.type_fr,
                        collaborators: []
                      };
                    }
                    acc[typeId].collaborators.push(collab);
                    return acc;
                  }, {});

                  // Convert to array and render
                  return Object.values(groupedCollaborators).map((group, index) => {
                    return (
                      <div key={index} className={index % 2 === 0 ? classes.details_row : classes.details_row1}>
                        <p style={{fontWeight:'700', textTransform:'capitalize'}}>{language === 'eng' ? group.type : group.type_fr}</p>
                        <p style={{fontWeight:'500', cursor:'pointer'}}>
                          {group.collaborators.map((collab, idx) => (
                            <span key={idx}>
                              <span
                                onClick={() => handleFilterCollaborator(collab.id)}
                                style={{cursor:'pointer', borderBottom: '1px solid var(--primary-color)'}}
                              >
                                {collab.nom}
                              </span>
                              {idx < group.collaborators.length - 1 && ', '}
                            </span>
                          ))}
                        </p>
                      </div>
                    );
                  });
                })()}
                <div className={classes.details_row}>
                  <p style={{ fontWeight: "700", width: "100%" }}>
                    {language === "eng" ? "Category" : "Categorie"}
                  </p>

                  {categoryItem && categoryItem?._nom && categoryItem?._nom !== "" && (
                    <>
                      <p
                        onClick={() => handleCatClick()}
                        style={{ color: "var(--accent-color)", cursor:'pointer' }}
                      >
                        {categoryItem?._nom}
                      </p>
                      <span
                        className={classes.subscribe}
                        onClick={(e) => {
                          handleSuivreCategory();
                          e.stopPropagation();
                        }}
                      >
                        <MdAddBox style={{ fontSize: "1.5em" }} />
                      </span>
                    </>
                  )}
                </div>
                <div className={classes.details_row1}>
                  <p style={{ fontWeight: "700", width: "100%" }}>
                    {language === "eng" ? "Collection" : "Collection"}
                  </p>
                  {selectedBook?.dc_collection &&
                    selectedBook?.dc_collection !== "" && (
                      <>
                        {" "}<p 
                                onClick={() => {
                                    localStorage.removeItem('categories'); 
                                    localStorage.removeItem('publishers'); 
                                    localStorage.removeItem('collections');
                                    dispatch(resetSearchData()); 
                                    
                                    // Get existing collections from localStorage or initialize empty array
                                    const existingCollections = JSON.parse(localStorage.getItem('collections')) || [];
                                    
                                    // Add the new collection ID if it doesn't already exist
                                    if (!existingCollections.includes(selectedBook?.b_usr_article_collection_id)) {
                                        existingCollections.push(selectedBook?.b_usr_article_collection_id);
                                    }
                                    
                                    // Store the updated array back to localStorage
                                    localStorage.setItem('collections', JSON.stringify(existingCollections)); 
                                    
                                    navigate(`/products`);
                                }}
                                style={{fontWeight:'500', cursor:'pointer'}}
                            >
                          {selectedBook?.dc_collection}
                        </p>
                        <span
                          className={classes.subscribe1}
                          onClick={(e) => {
                            handleSuivreCollection();
                            e.stopPropagation();
                          }}
                        >
                          <MdAddBox style={{ fontSize: "1.5em" }} />
                        </span>
                      </>
                    )}
                </div>
                <div className={classes.details_row}>
                  <p style={{ fontWeight: "700", width: "100%" }}>Nb pages</p>
                  <p style={{ color: "var(--accent-color)" }}>
                    {selectedBook?.nbpages}
                  </p>
                </div>
                <div className={classes.details_row1}>
                  <p style={{ fontWeight: "700", width: "100%" }}>
                    {language === "eng" ? "Dimensions" : "Dimensions"}
                  </p>
                  <p style={{ color: "var(--accent-color)" }}>
                    {selectedBook?.hauteur}mm x {selectedBook?.largeur}mm x{" "}
                    {selectedBook?.epaisseur}mm
                  </p>
                </div>
                <div className={classes.details_row}>
                  <p style={{ fontWeight: "700", width: "100%" }}>
                    {language === "eng" ? "Cover" : "Couverture"}
                  </p>
                  <p style={{ color: "var(--accent-color)" }}>
                    {selectedBook?.Couverture}
                  </p>
                </div>
                <div className={classes.details_row1}>
                  <p style={{ fontWeight: "700", width: "100%" }}>
                    {language === "eng" ? "Publication date" : "Date Parution"}
                  </p>
                  <p style={{ color: "var(--accent-color)" }}>
                    {selectedBook?.dc_parution?.substring(0, 10)}
                  </p>
                </div>
                <div className={classes.details_row}>
                  <p style={{ fontWeight: "700", width: "100%" }}>
                    {language === "eng" ? "Weight" : "Poids"}
                  </p>
                  <p style={{ color: "var(--accent-color)" }}>
                    {(selectedBook?._poids_net * 1).toFixed(2)}g
                  </p>
                </div>
                <div className={classes.details_row1}>
                  <p style={{ fontWeight: "700", width: "100%" }}>EAN13</p>
                  <p style={{ color: "var(--accent-color)" }}>
                    {selectedBook?._code_barre}
                  </p>
                </div>
                {selectedBook?.characteristics?.map((charac, index) => (
                  <div key={index} className={index % 2 === 0 ? classes.details_row : classes.details_row1}>
                    <p style={{ fontWeight: "500", width:'100%' }}>{charac.name}</p>
                    <p>{charac.multiproductData?.map((data, i) => (
                      <span key={i}><span
                          onClick={() => handleFilterMultiproduct(data.id)}
                          style={{ cursor: 'pointer', borderBottom: '1px solid var(--primary-color)' }}
                        >{data.name}</span>{i < charac.multiproductData.length - 1 ? ', ' : ''}</span>
                    ))}</p>
                  </div>
                ))}
              </div>
            )}
            {isclicked === "commentaires" && (
              <div className={classes.review}>
                <Reviews />
              </div>
            )}
          </div>
        </div>
        <div className={classes.swiper}></div>
      </div>
    </div>
  );
};

export default ViewTab;
